import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../state";

export const getChartQc = createAsyncThunk('getChartQc', async () => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/chart/qc',
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const getChartPrep = createAsyncThunk('getChartPrep', async () => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/chart/prep',
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const createPerformance = createAsyncThunk('createPerformance', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/performance',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editPerformance = createAsyncThunk('editPerformance', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/performance',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const getPerformanceDetail = createAsyncThunk('getPerformanceDetail', async (date: string) => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/performance/detail',
            params: { date }
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const getDaySessionList = createAsyncThunk('getDaySessionList', async (date: string) => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/performance/list/day',
            params: { date }
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const getPerformanceDetailSession = createAsyncThunk('getPerformanceDetailSession', async (datetime: string) => {
    try {
        const response = await axios({
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/performance/detail/session',
            params: { datetime }
        })
        return response
    } catch (error: any) {
        return error.response
    }
})